module.exports = __webpack_public_path__ + "img/btn_breast_off.32392c6a.svg";